import { MATCH_ALL, MATCH_ANY, MATCH_AUTO, MATCH_FUZZY, MATCH_LITERAL, MATCH_NONE, MATCH_REGEX } from '../constants/matching-algorithms'

export interface MatchingAlgorithmOption {
  value: number
  label: string
}

export const getMatchingAlgorithms = (t: (key: string) => string): MatchingAlgorithmOption[] => {
  return [
    {
      value: MATCH_AUTO,
      label: t('auto_learn_matching_automatically'),
    },
    {
      value: MATCH_ANY,
      label: t('any_document_contains_any_of_these_words_space_sep'),
    },
    {
      value: MATCH_ALL,
      label: t('all_document_contains_all_of_these_words_space_sep'),
    },
    {
      value: MATCH_LITERAL,
      label: t('exact_document_contains_this_string'),
    },
    {
      value: MATCH_REGEX,
      label: t('regular_expression_document_matches_this_regular_e'),
    },
    {
      value: MATCH_FUZZY,
      label: t('fuzzy_document_contains_a_word_similar_to_this_wor'),
    },
    {
      value: MATCH_NONE,
      label: t('none_disable_matching'),
    },
  ]
}

export const isPatternRequired = (matchingAlgorithm: number): boolean => {
  return matchingAlgorithm !== MATCH_AUTO && matchingAlgorithm !== MATCH_NONE
}
